import React from 'react'
import PanelHead from '../../Panel/PanelHead'
import PanelBody from '../../Panel/PanelBody'
import { TableShopAds } from './TableShopAds'

export const PanelShopAds = () => {
  return (
    <div>
         <PanelHead title='Shop Ads'/>
         <PanelBody content={<TableShopAds/>} />
    </div>
  )
}
